export default {
  sidebar: {
    bundle: 'Bundle',
    package: 'Paquete',
    dependency: 'Dependencia',
  },
};
